<template>
  <div>
    <div class="container pt-4">
      <h1 class="text-center mb-4">Settings</h1>
      <b-row class="justify-content-center">
        <b-col md="8" class="text-center py-3">
          <dashboard-tiles :items="settingsNavItems"></dashboard-tiles>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import DashboardTiles from "../components/dashboard/DashboardTiles"

  export default {
    components: { DashboardTiles },
    name: 'Settings',
    data() {
      return {
        isAuthenticated: this.$store.getters.isAuthenticated,
        authType: this.$store.getters.getAuthType,
        navItems: [
          { name: 'My Team', icon: 'fal fa-users', url: '/team' },
          { name: 'Results Sharing', icon: 'fal fa-share-alt', url: '/results-sharing' },
          { name: 'Customer Coords', icon: 'fal fa-address-book', url: '/customer-coords' },
          { name: 'Customer Integrations', icon: 'fal fa-link', url: '/customer-integration', availableOnTokenAuth: true },
        ]
      }
    },
    computed: {
      settingsNavItems ()  {
        if (this.isAuthenticated) {
          return this.navItems.filter(item => item.availableOnTokenAuth == !!(this.authType === 'token'));
        } else {
          return [];
        }
      }
    }
  }
</script>
